import styled from 'styled-components';
export const ProductDetailsWrapper = styled.div`
	margin: 24px 20px;
	border-radius: 8px;
	border: 1px solid var(--neutral-color-ff-neutral200);
	background: #fff;
	& .modal-container-bot {
		height: fit-content !important;
		width: fit-content !important;
		border-radius: 20px;
		padding: 12px 0 36px 0;
		text-align: center;
		& img {
			cursor: pointer;
			aspect-ratio: 2;
		}
		& .addtobagmodel {
			display: flex;
			flex-direction: column;
			align-items: center;
			max-width: ${(props) =>
				props.deviceType === 'mobile' ? '280px' : '423px'};
			padding: 0 24px;
			& > .title {
				margin: 20px 0 12px;
				font-weight: 600;
			}
			& > .desc {
				margin-bottom: 36px;
			}
			& > .buttons {
				max-width: ${(props) => (props.deviceType === 'mobile' ? '280px' : '')}
					& > .custom-button {
					& > button {
						font-family: var(--fontFamily);
						font-size: 16px;
						font-weight: 600;
					}
					& .MuiButton-root {
						&:not(.Mui-disabled):hover {
							&:after {
								background-color: var(--black-10);
								border-radius: 100px;
							}
						}
					}
				}
				& > .custom-button:first-child {
					margin-bottom: 12px;
					& > button {
						border-radius: 100px;
						background: var(--primary-color-ff-primary600);
						height: 40px;
						width: ${(props) =>
							props.deviceType === 'mobile' ? '100%' : '375px'};
						& > div {
							color: white;
						}
					}
				}
				& > .custom-button:last-child {
					& > button {
						border-radius: 100px;
						border: 1px solid var(--primary-color-ff-primary600);
						background: white;
						height: 40px;
						width: ${(props) =>
							props.deviceType === 'mobile' ? '100%' : '375px'};
						& > div {
							color: var(--primary-color-ff-primary600);
						}
					}
				}
			}
		}
	}
	& > .header-products {
		border-bottom: 1px solid var(--neutral-color-ff-neutral200);
		z-index: 1;
		background: white;
		& > .header {
			display: flex;
			justify-content: space-between;

			border-bottom: none;
			border-radius: 8px;
			margin-bottom: 8px;
			margin-top: 12px;
			margin-left: 12px;
			& > .backbutton-back {
				display: flex;
				align-items: center;
				gap: 6px;
				& > .backbutton {
					cursor: pointer;
					&:hover {
						& > svg {
							cursor: pointer;
							& .path {
								fill-opacity: 0.6 !important;
							}
						}
					}
				}
				& > .back {
					cursor: pointer;
					color: var(--primary-color-ff-primary900);
					font-family: var(--fontFamily);
					font-size: 12px;
					font-style: normal;
					font-weight: 400;
					line-height: 18px;
					letter-spacing: 0.4px;
				}
			}
		}
		& > .mainproduct-advisoryproducts {
			display: flex;
			justify-content: space-between;
			padding: 12px 16px;
			padding-top: 0;
			& > .mainproduct {
				cursor: pointer;
				&.true {
					& > div.image-holder {
						border-radius: 8px;
						outline: 2px solid var(--primary-color-ff-primary600);
						outline-offset: 2px;
					}
				}
				& > div.image-holder {
					min-width: 36px;
					& > img {
						width: 76px;
						border-radius: 8px;
						border: 1px solid var(--neutral-color-ff-neutral200, #d2d7dc);
						object-fit: cover;
						object-position: 50%;
					}
				}
			}
			& > .advisoryproducts {
				display: flex;
				align-items: center;
				gap: 12px;
				padding: 4px;
				overflow-x: auto;
				max-width: calc(100% - 100px);
				-webkit-overflow-scrolling: touch;
				scrollbar-width: none; /* Firefox */
				-ms-overflow-style: none; /* Internet Explorer 10+ */
				&::-webkit-scrollbar {
					display: none; /* Safari and Chrome */
				}
				& > .product {
					cursor: pointer;
					min-width: 100px;
					&.true {
						& > div.image {
							& > img {
								outline: 2px solid var(--primary-color-ff-primary600);
								outline-offset: 2px;
							}
						}
						& > div.productType {
							font-weight: 600;
							color: var(--primary-color-ff-primary600);
						}
					}

					& > div.productType {
						color: var(--primary-color-ff-primary900);
						text-align: center;
						font-family: var(--fontFamily);
						font-size: 12px;
						font-style: normal;
						font-weight: 400;
						line-height: 18px;
						letter-spacing: 0.4px;
						margin-top: 4px;
						height: 18px;
						text-transform: capitalize;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						max-width: 100px;
						-webkit-box-orient: vertical;
						overflow: hidden;
					}
					& > div.image > img {
						width: 100px;
						aspect-ratio: 1;
						object-fit: contain;
						border-radius: 8px;
						border: 1px solid var(--neutral-color-ff-neutral200);
					}
				}
			}
		}
	}
	& .ff-details-complete-look {
		display: flex;
		padding: 24px 0;
	}
	& .ff-complete-the-look {
		padding: 8px 16px 16px 16px;
		display: flex;
		flex-direction: column;
		border-radius: 12px;
		border: 1px solid #e2d2f8;
		background: #f9f5ff;
		gap: 10px;
		margin-right: 20px;
		height: fit-content;
		max-width: 130px;
		& .ctl {
			color: var(--secondary-color-ff-secondary500);
			font-family: var(--fontFamily);
			font-size: 13px;
			font-style: normal;
			font-weight: 700;
			line-height: 21px;
			letter-spacing: 0.42px;
		}
		& > div:not(.heading) {
			outline: none !important;

			& > div {
				outline: none !important;
				background: #f9f5ff;
				border-radius: 8px;
				border: none;
				& > img {
					border-radius: 8px !important;
					border-bottom: none;
				}
				& > .content {
					background: #f9f5ff;
				}
			}
		}
	}
	& .details {
		padding: 24px 20px;
		padding-top: 0;
		width: calc(100% - 224px);
		&.changeWidth {
			width: calc(100% - 40px);
		}

		border-radius: 0 0 12px 12px;
		& > .product-details {
			display: grid;
			margin-bottom: 36px;
			grid-template-columns: auto auto;
			& > div.all-details {
				max-width: 460px;
				min-width: 200px;
				& > .product-details-rating-title {
					margin-bottom: 16px;
					& > .brand-name {
						color: var(--neutral-color-ff-neutral600);
						font-family: var(--fontFamily);
						font-size: 14px;
						font-style: normal;
						font-weight: 400;
						line-height: 21px;
						letter-spacing: 0.42px;
						text-transform: capitalize;
					}
					& > .rating {
						padding-top: 8px;
						display: flex;
						align-items: center;
						gap: 6px;
						& > .stars {
							display: flex;
							align-items: center;
						}
						& > .users {
							color: var(--black-60, rgba(0, 0, 0, 0.6));
						}
						& > .number {
							position: relative;
							top: 1px;
							// color: #845b1d;
							color: var(--primary-color-ff-primary600);
							font-size: 14px;
							font-style: normal;
							font-weight: 500;
							line-height: 21px;
							letter-spacing: 0.42px;
						}
					}
					& > .title {
						// color: var(--color-scale-1, #1b1306);
						color: var(--primary-color-ff-primary900);
						font-family: var(--fontFamily, Montserrat);
						font-size: 20px;
						font-style: normal;
						font-weight: 600;
						line-height: 28px;
						letter-spacing: 0.6px;
					}
				}

				& > .product-grid-and-main-image {
					display: grid;
					gap: 8px;
					grid-template-columns: 48px 1fr;
					& > .main-image {
						aspect-ratio: 2/3;
						border-radius: 8px;
						border: 1px solid var(--neutral-color-ff-neutral200);
						background: var(--neutral-color-ff-neutral100);
						display: flex;
						align-items: center;
						justify-content: center;
						overflow: hidden;
						& > img {
							width: 100%;
							height: 100%;
							border-radius: 7px;
							transition: opacity 0.5s ease-in-out;
							opacity: 0;
							&.show {
								opacity: 1;
							}
						}
					}
					& > .product-grid {
						display: flex;
						flex-direction: column;
						gap: 8px;
						overflow: auto;
						max-height: 500px;
						-webkit-overflow-scrolling: touch;
						scrollbar-width: none; /* Firefox */
						-ms-overflow-style: none; /* Internet Explorer 10+ */
						&::-webkit-scrollbar {
							display: none; /* Safari and Chrome */
						}
						& > div {
							cursor: pointer;
							min-height: 48px;
							padding: 2px;
							// width: 100%;
							overflow: hidden;
							max-height: 72px;
							&.true {
								& > img {
									outline: 1px solid var(--primary-color-ff-primary600);
									outline-offset: 1px;
								}
							}
							& > img {
								object-fit: cover;
								height: 96%;
								width: 96%;
								border-radius: 8px;
								border: 1px solid var(--neutral-color-ff-neutral200);
							}
						}
					}
				}
			}
			& > .product-details-variants-and-add-to-bag {
				margin-left: 24px;

				& > .details-variants {
					width: 100%;
					& > .recomm-details {
						& > .why-recommend {
							display: flex;
							flex-direction: column;
							justify-content: center;
							margin-bottom: 28px;
							// padding-bottom: 12px;
							// border-bottom: 1px solid var(--black-10, rgba(0, 0, 0, 0.1));
							padding: 12px 16px;
							border-radius: 12px;
							border: 1px solid var(--primary-color-ff-primary100);
							background: var(--primary-color-ff-primary50);
							& > .title-and-icon-holder {
								margin-bottom: 10px;
								& > div.title {
									color: var(--secondary-color-ff-secondary600);
									font-family: var(--fontFamily);
									font-size: 20px;
									font-style: normal;
									font-weight: 600;
									line-height: 28px;
									letter-spacing: 0.6px;
								}
								& > span {
									& > svg {
										cursor: pointer;
									}
								}
							}
							& > .description {
								font-family: var(--fontFamily);
								color: var(--primary-color-ff-primary900);
								font-size: 16px;
								font-style: normal;
								font-weight: 400;
								line-height: 24px;
								letter-spacing: 0.32px;
							}
						}
					}
					& > .variants {
						// border-top: 1px solid var(--black-10, rgba(0, 0, 0, 0.1));
						// padding-top: 12px;
						display: flex;
						flex-direction: column;

						& > .price-bag {
							& > .price {
								color: var(--text-colored-text, #624315);
								display: flex;
								align-items: center;
								flex-wrap: wrap;
								& > span:nth-child(2) {
									font-size: 30px;
								}
								& > .sale-price {
									overflow: hidden;
									color: var(--secondary-color-ff-secondary600);
									font-family: var(--fontFamily);
									font-size: 30px;
									font-style: normal;
									font-weight: 600;
									line-height: 40px;
									letter-spacing: 0.29px;
									& > span:last-child {
										margin-right: 10px;
									}
								}
								& > .striked-price {
									overflow: hidden;
									color: var(--neutral-color-ff-neutral600);
									text-overflow: ellipsis;
									font-family: var(--fontFamily);
									font-size: 20px;
									font-style: normal;
									font-weight: 400;
									line-height: 40px;
									letter-spacing: 0.29px;
									& > span {
										text-decoration: line-through;
									}
									& > span:last-child {
										margin-right: 10px;
									}
								}
								& > .discount-percent {
									overflow: hidden;
									color: var(--secondary-color-ff-secondary600);
									text-overflow: ellipsis;
									font-family: var(--fontFamily);
									font-size: 20px;
									font-style: normal;
									font-weight: 600;
									line-height: 28px;
									letter-spacing: 0.6px;
									& > span:last-child {
										margin-right: 10px;
									}
									text-align: center;
								}
							}
							& > .add-to-bag-button {
								flex: 1;
								& > div {
									& > button {
										width: 100%;
										border-radius: 100px;
										background: var(--primary-color-ff-primary600, #7242e1);
										padding: 5px 12px;
										height: 40px;
										font-size: 16px;
										font-weight: 600;
									}
								}
							}
						}
						& > .desc {
							color: var(--primary-color-ff-primary900);
							font-family: var(--fontFamily);
							font-size: 16px;
							font-style: normal;
							font-weight: 400;
							line-height: 24px;
							letter-spacing: 0.32px;
						}
						& > .sizes {
							border-bottom: 1px solid var(--black-10, rgba(0, 0, 0, 0.1));
							padding-bottom: 24px;
							margin-top: 7px;
							display: flex;
							align-items: center;
							gap: 6px;
							& > .common-size-css {
								padding: 4px 10px;
								// border-radius: var(--border-radius-size-1, 4px);
								border-radius: 20px;
								border: 1px solid rgba(0, 0, 0, 0.2);
							}
						}
						& > .colors {
							margin-bottom: 24px;
							display: flex;
							align-items: center;
							gap: 8px;
							margin-top: 7px;
							& > div.show {
								border: 2px solid #881010;
							}
							& > div {
								border-radius: 50%;
								padding: 2px;

								& > div.common-css {
									width: 30px;
									height: 30px;
									padding: 2px;
								}
								& > .color-0,
								& > .color-1,
								& > .color-2,
								& > .color-3,
								& > .color-4 {
									border-radius: 50%;
									padding: 2px;
									width: 100%;
									height: 100%;
								}
								& > .color-0 {
									background-color: #881010;
								}
								& > .color-1 {
									background-color: #078240;
								}
								& > .color-2 {
									background-color: #731083;
								}
								& > .color-3 {
									background-color: #bf8900;
								}
								& > .color-4 {
									background-color: #008395;
								}
							}
						}

						& > .price-bag {
							margin-top: 12px;
							margin-bottom: 24px;
							display: flex;
							gap: 48px;
						}
					}
				}
			}
		}
		& > .more-like-this {
			& > .heading {
				margin-bottom: 16px;

				& > .text {
					color: var(--primary-color-ff-primary900);
					font-family: var(--fontFamily);
					font-size: 16px;
					font-style: normal;
					font-weight: 600;
					line-height: 24px;
					letter-spacing: 0.32px;
				}
			}
			& > .complementaryproducts {
				& > .morelikethisloader {
					display: flex;
					gap: 10px;
					width: 100%;

					& > div {
						cursor: wait;
						height: 270px;
						width: 180px;
						animation: change-background-color 3s linear infinite;

						& > .child {
							height: 270px;
							width: 180px;
							background: linear-gradient(
								135deg,
								rgba(255, 255, 255, 0) 25%,
								rgba(255, 255, 255, 1) 50%,
								rgba(255, 255, 255, 0) 75%
							);
							background-size: 300% 300%;
							animation: move-gradient 1.5s ease infinite;
						}
						&.parent-0 {
							animation-delay: -0.75s;
						}
						&.parent-1 {
							animation-delay: -1.5s;
						}
						&.parent-2 {
							animation-delay: -3s;
						}
						&.parent-3 {
							animation-delay: -2.25s;
						}
						&.parent-4 {
							animation-delay: -0.75s;
						}
					}
				}
				& > .morelikethiscontainer {
					& > .slider-container {
						& > .slick-slider {
							& > .left-button,
							& > .right-button {
								transform: translateY(-50%);
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
	&.mobile {
		margin: unset;
		border-radius: unset;
		border: none;
		background: none;
		padding: 0 12px;
		padding-bottom: 35px;
		padding-right: 4px;
		& > .header-products {
			border-bottom: none;
			background: var(--primary-color-ff-primary50);
			position: sticky;
			top: -25px;
			& > .header {
				margin: 0;
				padding: 10px 12px;
				background: var(--primary-color-ff-primary50);
				position: relative;
				left: -12px;
				width: 100vw;
				padding-left: 12px;
				border-radius: 0;
			}
			& > .mainproduct-advisoryproducts {
				display: none;
			}
		}
		& > .modal-overlay-bot {
			justify-content: center;
			& > .modal-container-bot {
				max-width: calc(100% - 30px) !important;
				width: 100% !important;
				& .addtobagmodel {
					max-width: unset !important;
					& > .buttons {
						max-width: unset !important;
						width: 100%;
					}
				}
			}
		}
	}
`;

export const MobileProductDetailsWrapper = styled.div`
	.complete-the-look {
		margin: 24px 0;
		& > .heading {
			margin-bottom: 16px;

			& > .text {
				color: var(--primary-color-ff-primary900);
				font-family: var(--fontFamily);
				font-size: 16px;
				font-style: normal;
				font-weight: 600;
				line-height: 24px;
				letter-spacing: 0.32px;
			}
		}
	}
	& > .image {
		background-image: url(${(props) => props.backgroundImage});
		background-repeat: no-repeat;
		background-size: contain;
		background-position-x: center;
		background-position-y: center;
		position: relative;
		transition: background-image 0.5s ease-in-out;
		aspect-ratio: 2/3;
		border-radius: 12px;
	}
	& > .carousel-dots {
		display: flex;
		gap: 8px;
		justify-content: center;
		margin: 8px 0 16px 0;
	}
	& > .brand-name {
		color: var(--neutral-color-ff-neutral600);
		font-weight: 400;
		letter-spacing: 0.42px;
		text-transform: capitalize;
	}
	& > .rating {
		display: none;
		display: flex;
		align-items: center;
		gap: 6px;
		& > .stars {
			display: flex;
			align-items: center;
		}
		& > .users {
			color: var(--black-60, rgba(0, 0, 0, 0.6));
		}
		& > .number {
			position: relative;
			top: 1px;
			color: var(--primary-color-ff-primary600);
			font-size: 14px;
			font-style: normal;
			font-weight: 500;
			line-height: 21px;
			letter-spacing: 0.42px;
		}
		margin-bottom: 16px;
	}
	& > .title {
		color: var(--primary-color-ff-primary900);
		letter-spacing: 0.6px;
		margin-bottom: 16px; // remove when rating is enabled
	}
	& > .price-bag {
		position: fixed;
		bottom: 0;
		width: 100vw;
		background-color: #fff;
		z-index: 10;
		& > div {
			position: relative;
			left: -12px;
			border-top: 1px solid var(--neutral-color-ff-neutral200);
			border-bottom: 1px solid var(--neutral-color-ff-neutral200);
			padding: 12px;
			display: flex;
			gap: 32px;
			height: 60px;
			align-items: center;
			& > .price {
				color: var(--text-colored-text, #624315);
				display: flex;
				align-items: center;
				flex-direction: column;

				& > span:nth-child(2) {
					font-size: 30px;
				}
				& > .sale-price {
					overflow: hidden;
					color: var(--secondary-color-ff-secondary600);
					font-family: var(--fontFamily);
					font-size: 30px;
					font-style: normal;
					font-weight: 600;
					line-height: 40px;
					letter-spacing: 0.29px;
					& > span:last-child {
						margin-right: 10px;
					}
				}
				& > .striked-discount-price {
					display: flex;
					align-items: center;
					& > .striked-price {
						overflow: hidden;
						color: var(--neutral-color-ff-neutral600);
						text-overflow: ellipsis;
						font-family: var(--fontFamily);
						font-size: 14px;
						font-style: normal;
						font-weight: 400;
						line-height: 1.5;
						letter-spacing: 0.42px;
						& > span {
							text-decoration: line-through;
						}
						& > span:last-child {
							margin-right: 10px;
						}
					}
					& > .discount-percent {
						overflow: hidden;
						color: var(--secondary-color-ff-secondary600);
						text-overflow: ellipsis;
						font-family: var(--fontFamily);
						font-size: 14px;
						font-style: normal;
						font-weight: 600;
						line-height: 28px;
						letter-spacing: 0.42px;
						& > span:last-child {
							margin-right: 10px;
						}
					}
				}
			}
			& > .add-to-bag-button {
				flex: 1;
				align-self: center;
				max-width: calc(100vw - 170px);
				& > div {
					& > button {
						width: 100%;
						border-radius: 100px;
						background-color: var(
							--primary-color-ff-primary600,
							#7242e1
						) !important;
						padding: 5px 12px;
						height: 40px;
						font-size: 16px;
						font-weight: 600;
					}
				}
			}
		}
	}
	& > .product-details-variants-and-add-to-bag-mobile {
		& > .details-variants {
			width: 100%;
			& > .recomm-details {
				& > .why-recommend {
					display: flex;
					flex-direction: column;
					justify-content: center;
					margin-bottom: 16px;
					padding: 12px 16px;
					border-radius: 12px;
					border: 1px solid var(--primary-color-ff-primary100);
					background: white;
					& > .title-and-icon-holder {
						margin-bottom: 10px;
						& > div.title {
							color: var(--secondary-color-ff-secondary600);
							font-family: var(--fontFamily);
							font-size: 20px;
							font-style: normal;
							font-weight: 600;
							line-height: 28px;
							letter-spacing: 0.6px;
						}
						& > span {
							& > svg {
								cursor: pointer;
							}
						}
					}
					& > .description {
						font-family: var(--fontFamily);
						color: var(--primary-color-ff-primary900);
						font-size: 16px;
						font-style: normal;
						font-weight: 400;
						line-height: 24px;
						letter-spacing: 0.32px;
					}
				}
			}
			& > .variants {
				display: flex;
				flex-direction: column;

				& > .desc {
					color: var(--primary-color-ff-primary900);
					font-family: var(--fontFamily);
					font-size: 16px;
					font-style: normal;
					font-weight: 400;
					line-height: 24px;
					letter-spacing: 0.32px;
				}
				& > .sizes {
					border-bottom: 1px solid var(--black-10, rgba(0, 0, 0, 0.1));
					padding-bottom: 24px;
					margin-top: 7px;
					display: flex;
					align-items: center;
					gap: 6px;
					& > .common-size-css {
						padding: 4px 10px;
						// border-radius: var(--border-radius-size-1, 4px);
						border-radius: 20px;
						border: 1px solid rgba(0, 0, 0, 0.2);
					}
				}
				& > .colors {
					margin-bottom: 24px;
					display: flex;
					align-items: center;
					gap: 8px;
					margin-top: 7px;
					& > div.show {
						border: 2px solid #881010;
					}
					& > div {
						border-radius: 50%;
						padding: 2px;

						& > div.common-css {
							width: 30px;
							height: 30px;
							padding: 2px;
						}
						& > .color-0,
						& > .color-1,
						& > .color-2,
						& > .color-3,
						& > .color-4 {
							border-radius: 50%;
							padding: 2px;
							width: 100%;
							height: 100%;
						}
						& > .color-0 {
							background-color: #881010;
						}
						& > .color-1 {
							background-color: #078240;
						}
						& > .color-2 {
							background-color: #731083;
						}
						& > .color-3 {
							background-color: #bf8900;
						}
						& > .color-4 {
							background-color: #008395;
						}
					}
				}

				& > .price-bag {
					margin-top: 12px;
					margin-bottom: 24px;
					display: flex;
					gap: 48px;
				}
			}
		}
	}
	& > .more-like-this {
		& > .heading {
			margin-bottom: 16px;

			& > .text {
				color: var(--primary-color-ff-primary900);
				font-family: var(--fontFamily);
				font-size: 16px;
				font-style: normal;
				font-weight: 600;
				line-height: 24px;
				letter-spacing: 0.32px;
			}
		}
		& > .complementaryproducts {
			& > .morelikethisloader {
				display: flex;
				gap: 10px;
				width: 100%;

				& > div {
					cursor: wait;
					height: 270px;
					width: 180px;
					animation: change-background-color 3s linear infinite;

					& > .child {
						height: 270px;
						width: 180px;
						background: linear-gradient(
							135deg,
							rgba(255, 255, 255, 0) 25%,
							rgba(255, 255, 255, 1) 50%,
							rgba(255, 255, 255, 0) 75%
						);
						background-size: 300% 300%;
						animation: move-gradient 1.5s ease infinite;
					}
					&.parent-0 {
						animation-delay: -0.75s;
					}
					&.parent-1 {
						animation-delay: -1.5s;
					}
					&.parent-2 {
						animation-delay: -3s;
					}
					&.parent-3 {
						animation-delay: -2.25s;
					}
					&.parent-4 {
						animation-delay: -0.75s;
					}
				}
			}
			& > .morelikethiscontainer {
				& > .slider-container {
					& > .slick-slider {
						& > .left-button,
						& > .right-button {
							transform: translateY(-50%);
							cursor: pointer;
						}
					}
				}
			}
		}
	}
`;
export const ProductVariants = styled.div`
	& > .choices {
		& > div {
			& > .title {
				margin-top: 16px;
				margin-bottom: 8px;
				color: #000;
				font-family: var(--fontFamily);
				font-size: 14px;
				font-style: normal;
				font-weight: 500;
				line-height: 21px;
				letter-spacing: 0.42px;
			}
			& > .MuiFormGroup-root {
				display: flex;
				cursor: pointer;
				display: -webkit-box;

				& > label {
					border-radius: 20px;
					margin-right: 6px;
					margin-left: unset;
					&.active {
						background: var(--primary-color-ff-primary600);
						color: #fff;
					}
					&:hover {
						background: var(--primary-color-ff-primary100);
					}

					padding: 6px 12px;
					text-transform: capitalize;
					border: 1px solid rgba(0, 0, 0, 0.2);
					color: rgba(0, 0, 0, 0.6);
					text-align: center;
					font-family: var(--fontFamily);
					font-size: 14px;
					font-style: normal;
					font-weight: 500;
					line-height: 21px;
					letter-spacing: 0.42px;
					& > span:first-child {
						display: none;
					}
				}
			}
		}
	}
`;
